const categoryList = [
    {
        "id": 1,
        "name": "دیجیتال و الکترونیکی",
        "icon": "digital.png"
    },
    {
        "id": 2,
        "name": "ورزشی و تفریحی",
        "icon": "sports.png"
    },
    {
        "id": 3,
        "name": "ابزارآلات",
        "icon": "tools.png"
    },
    {
        "id": 4,
        "name": "مراسم و رویدادها",
        "icon": "event.png"
    },
    {
        "id": 5,
        "name": "فرهنگی، هنری و آموزشی",
        "icon": "art.png"
    },
    {
        "id": 6,
        "name": "مد، پوشاک و زیبایی",
        "icon": "cloth.png"
    },
    {
        "id": 7,
        "name": "سلامت و پزشکی",
        "icon": "health.png"
    },
    {
        "id": 8,
        "name": "وسایل نقلیه صنعتی",
        "icon": "industrial.png"
    }
]
export default categoryList;